import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./TestingIBOPreview.module.css";
import classNames from "classnames";
import Button from "../Button";
import SquareO from "../../assests/square-o-icon.svg";
import SpanInput from "../SpanInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";

/**
 * Interactive component. A multi-purpose button that changes appearance on hover.
 */

export function TestingIBOPreview({ IBONumber, setIBONumber }) {
  const [isOpen, setIsOpen] = useState(IBONumber != 0);

  return (
    <div className={styles.container}>
      <h5 className={styles.title}>Testing</h5>

      {!isOpen ? (
        <>
          <button
            className={styles.button}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <img src={SquareO} alt="Square Icon" className={styles.icon} />
            <div className={styles.text}>Test Preview IBO# </div>
          </button>
        </>
      ) : (
        <>
          <div className={styles.testContainer}>
            <div
              className={styles.testItem}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              <span>
                <FontAwesomeIcon
                  icon={faCheckSquare}
                  style={{ marginRight: "5px", width: "12px", color: "blue" }}
                />
              </span>
              <p className={styles.label}>Test Preview IBO# </p>
            </div>
            <div className={styles.testItem}>
              <input
                className={styles.input}
                type="number"
                id="iboNumber"
                name="iboNumber"
                value={IBONumber}
                placeholder="0"
                onChange={setIBONumber}
              />
            </div>
            <div className={styles.testItem}>
              <button className={styles.btnDesign} onClick={() => setIBONumber({target: { value: 138}})}>Design Group</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

TestingIBOPreview.propTypes = {
  /**
   * Determines the input IBO number.
   */
  IBONumber: PropTypes.number,

  /**
   * Function that fires when the IBONumber changes.
   */
  setIBONumber: PropTypes.func,
};
